import type { PartialStoreState } from '../typings'

export const selectGpsTags = (state: PartialStoreState) =>
  state.domain.publicData.domain.gps.wwgps.tags
